// import logo from './logo.svg';
import './App.css';
import CryptoTable from './component/cryptoprice';

function App() {
  return (
    <div className="App">
      <CryptoTable/>
    </div>
  );
}

export default App;
